import { isPresent } from '../utils';
// tslint:enable:max-line-length
/**
 * @hidden
 * Type guard for `CompositeFilterDescriptor`.
 */
export var isCompositeFilterDescriptor = function (source) {
    return isPresent(source.filters);
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-data-query/dist/es/filtering/filter-descriptor.interface.js
// module id = 87
// module chunks = 93